export enum NotifierMessage {
    INVALID_USERNAME = "notifier.invalid_username.generic",
    INVALID_USERNAME_LENGTH = "notifier.invalid_username.length",
    INVALID_PASSWORD = "notifier.invalid_password.generic",
    INVALID_CURRENT_PASSWORD = "notifier.invalid_password.current",
    INVALID_PASSWORD_LENGTH = "notifier.invalid_password.length",
    NOT_SET_PASSWORD = "notifier.password_change.not_set_password",
    NOT_SAME_PASSWORD = "notifier.password_change.not_same_password",

    LOGIN_GENERIC = "notifier.login.generic",
    LOGIN_USER_DOESNT_EXISTS = "notifier.login.user_doesnt_exists",
    LOGIN_WRONG_PASSWORD = "notifier.login.wrong_password",
    LOGIN_PASSWORD_CHANGE_REQUIRED = "notifier.login.password_change_required",
    LOGIN_OPERATOR_NOT_AUTH = "notifier.login.operator_not_auth",
    LOGIN_USER_ALREADY_LOGGED = "notifier.login.user_already_logged",

    LOGOUT_GENERIC = "notifier.logout.generic",
    LOGOUT_USER_NOT_ALLOWED = "notifier.logout.user_not_allowed",

    PASSWORD_CHANGE_GENERIC = "notifier.password_change.generic",
    PASSWORD_CHANGE_SAME_PASSWORD = "notifier.password_change.same_password",
    PASSWORD_CHANGE_WRONG_PASSWORD = "notifier.password_change.wrong_password",

    DEVICE_ACTIVATION_NOT_EXIST = "notifier.device.activation.not_exist",
    DEVICE_CALENDAR_U_GENERIC = "notifier.device_calendar.update.generic",
    DEVICE_CALENDAR_U_NOT_AUTH = "notifier.device_calendar.update.not_auth",
    DEVICE_CALENDAR_U_INVALID_OPEN_TIME = "notifier.device_calendar.update.invalid_open_time",
    DEVICE_CALENDAR_U_INVALID_CLOSE_TIME = "notifier.device_calendar.update.invalid_close_time",
    DEVICE_CALENDAR_U_TIME_SUPERIMPOSED = "notifier.device_calendar.update.time_superimposed",
    DEVICE_CALENDAR_D_GENERIC = "notifier.device_calendar.delete.generic",
    DEVICE_CALENDAR_D_NOT_AUTH = "notifier.device_calendar.delete.not_auth",
    DEVICE_CALENDAR_S_GENERIC = "notifier.device_calendar.status.generic",
    DEVICE_CALENDAR_S_NOT_AUTH = "notifier.device_calendar.status.not_auth",

    SERVICE_CALENDAR_U_GENERIC = "notifier.service_calendar.update.generic",
    SERVICE_CALENDAR_U_NOT_AUTH = "notifier.service_calendar.update.not_auth",
    SERVICE_CALENDAR_U_INVALID_OPEN_TIME = "notifier.service_calendar.update.invalid_open_time",
    SERVICE_CALENDAR_U_INVALID_CLOSE_TIME = "notifier.service_calendar.update.invalid_close_time",
    SERVICE_CALENDAR_U_TIME_SUPERIMPOSED = "notifier.service_calendar.update.time_superimposed",
    SERVICE_CALENDAR_D_GENERIC = "notifier.service_calendar.delete.generic",
    SERVICE_CALENDAR_D_NOT_AUTH = "notifier.service_calendar.delete.not_auth",
    SERVICE_CALENDAR_S_GENERIC = "notifier.service_calendar.status.generic",
    SERVICE_CALENDAR_S_NOT_AUTH = "notifier.service_calendar.status.not_auth",

    CALLMODE_L_GENERIC = "notifier.callmode.list.generic",
    CALLMODE_L_NOT_AUTH = "notifier.callmode.list.not_auth",
    CALLMODE_U_GENERIC = "notifier.callmode.update.generic",
    CALLMODE_U_NOT_AUTH = "notifier.callmode.update.not_auth",

    COUNTER_SERVICE_L_GENERIC = "notifier.counter_service.list.generic",
    COUNTER_SERVICE_L_NOT_AUTH = "notifier.counter_service.list.not_auth",
    COUNTER_SERVICE_SET_GENERIC = "notifier.counter_service.set.generic",
    COUNTER_SERVICE_SET_NOT_AUTH = "notifier.counter_service.set.not_auth",
    COUNTER_SERVICE_UNSET_GENERIC = "notifier.counter_service.unset.generic",
    COUNTER_SERVICE_UNSET_NOT_AUTH = "notifier.counter_service.unset.not_auth",

    STATISTIC_UNAUTH_USER = "notifier.statistics.unauth_user",
    STATISTIC_UNAUTH_USER_RESOURCE = "notifier.statistics.unauth_user_resource",
    STATISTIC_WRONG_DATE_FORMAT = "notifier.statistics.wrong_date_format",
    STATISTIC_INVALID_DATE_TO = "notifier.statistics.invalid_date_to",
    STATISTIC_INVALID_SC = "notifier.statistics.invalid_sc",
    STATISTIC_INVALID_DT = "notifier.statistics.invalid_dt",
    STATISTIC_INVALID_PERIOD = "notifier.statistics.invalid_period",
    STATISTIC_SPECIFY_JUST_SITE_OR_ORG = "notifier.statistics.specify_just_org_site",

    TOKEN_HAS_EXPIRED = "notifier.token.has_expired",

    INVALID_HUB_ID = "notifier.hub.invalid_id",
    INVALID_ORG_ID = "notifier.org.invalid_id",
    INVALID_ORG_NAME = "notifier.org.invalid_name",
    INVALID_ORG_ZIPCODE = "notifier.org.invalid_zipcode",
    INVALID_ORG_ADDRESS = "notifier.org.invalid_address",
    INVALID_ORG_ADDRESS_NUMBER = "notifier.org.invalid_address_number",
    INVALID_ORG_EMAIL = "notifier.org.invalid_email",
    INVALID_ORG_PHONE = "notifier.org.invalid_phone",
    INVALID_ORG_PLACE_ID = "notifier.org.invalid_place",
    INVALID_ORG_MUNICIPALITY = "notifier.org.invalid_municipality",
    INVALID_ORG_LATITUDE = "notifier.org.invalid_latitude",
    INVALID_ORG_LONGITUDE = "notifier.org.invalid_longitude",

    INVALID_SLOT_DATE = "notifier.slot.invalid_date",
    INVALID_SLOT_TIME = "notifier.slot.invalid_time",
    INVALID_SLOT_ID = "notifier.slot.invalid_id",

    INVALID_SITE_ID = "notifier.site.invalid_id",
    INVALID_SITE_NAME = "notifier.site.invalid_name",
    INVALID_SITE_ZIPCODE = "notifier.site.invalid_zipcode",
    INVALID_SITE_ADDRESS = "notifier.site.invalid_address",
    INVALID_SITE_LATITUDE = "notifier.site.invalid_latitude",
    INVALID_SITE_LONGITUDE = "notifier.site.invalid_longitude",
    INVALID_SITE_PLACE_ID = "notifier.site.invalid_place_id",

    INVALID_SERVICE_NAME_1 = "notifier.service.invalid_name_1",
    INVALID_SERVICE_NAME_2 = "notifier.service.invalid_name_2",
    INVALID_SERVICE_NAME_3 = "notifier.service.invalid_name_3",
    INVALID_SERVICE_NAME_4 = "notifier.service.invalid_name_4",
    INVALID_SERVICE_NAME_5 = "notifier.service.invalid_name_5",
    INVALID_SERVICE_NAME_6 = "notifier.service.invalid_name_6",

    INVALID_MESSAGE_ID = "notifier.message.invalid_id",
    INVALID_MSG_NAME = "notifier.message.invalid_name",
    INVALID_MSG_DATE_BEGIN = "notifier.message.invalid_date_begin",
    INVALID_MSG_DATE_END = "notifier.message.invalid_date_end",
    INVALID_MSG_VISIBILITY = "notifier.message.invalid_visibility",

    INVALID_OPE_NAME = "notifier.operator.invalid_name",
    INVALID_OPE_AUTH_LEVEL = "notifier.operator.invalid_auth_level",

    INVALID_SERVICE_ID = "notifier.service.invalid_id",
    INVALID_SER_NAME = "notifier.service.invalid_name",
    INVALID_SER_TICKET_PREFIX = "notifier.service.invalid_ticket_prefix",
    INVALID_SER_BOOK_PREFIX = "notifier.service.invalid_book_prefix",

    INVALID_DEVICE_ID    = "notifier.device.invalid_id",
    INVALID_DEVICE_NAME  = "notifier.device.invalid_name",
    INVALID_COUNTER_NAME = "notifier.device.counter.invalid_name",
    INVALID_SPEECH_COUNTER_NAME = "notifier.device.counter.invalid_counter_name",
    INVALID_SPEECH_COUNTER_MSG  = "notifier.device.counter.invalid_counter_msg",

    INVALID_OPERATOR_ID = "notifier.operator.invalid_id",
    INVALID_OPERATOR_NAME = "notifier.operator.invalid_name",
    INVALID_TYPE = "notifier.type.invalid_number",
    INVALID_CALLMODE_ID = "notifier.callmode.invalid_id",

    INVALID_CALENDAR_ID = "notifier.calendar.invalid_id",
    INVALID_CALENDAR_DOW = "notifier.calendar.invalid_dow",
    INVALID_CALENDAR_OPEN = "notifier.calendar.invalid_open",
    INVALID_CALENDAR_CLOSE = "notifier.calendar.invalid_close",
    INVALID_CALENDAR_TIME = "notifier.calendar.invalid_time",

    INVALID_TIME_ID = "notifier.time.invalid_id",
    INVALID_GENERIC_ID = "notifier.generic.invalid_id",

    INVALID_CUSTOM_NAME = "notifier.generic.invalid_custom_name",

    OPERATOR_INVALID_LOGIN_ID = "notifier.operator.invalid_login_id",

    MESSAGE_INVALID_MESSAGE_ID = "notifier.message.invalid_message_id",

    MESSAGE_INVALID_DATE_SIZE = "notifier.message.invalid_date_size",

    SLOT_INVALID_DATE_IN = "notifier.slot.invalid_date_in",
    SLOT_LESS_CURRENT_DATE = "notifier.slot.less_current_date",
    SLOT_DAY_NOT_FOUND = "notifier.slot.day_not_found",
    SLOT_INVALID_TYPE = "notifier.slot.invalid_type",
    SLOT_BOOK_NOT_EXIST = "notifier.slot.book_not_exist",
    SLOT_BOOK_LESS_CURRENT_DATE = "notifier.slot.book_less_current_date",
    SLOT_BOOK_ONLY_TODAY = "notifier.slot.book_only_today",
    SLOT_TIME_JUST_PASSED = "notifier.slot.time_just_passed",
    SLOT_PRENOTATION_EXIST = "notifier.slot.prenotation_exist",
    SLOT_TIME_UNAVAILABLE = "notifier.slot.time_unavailable",
    SLOT_INVALID_ID = "notifier.slot.slot_invalid_id",
    SLOT_TIME_CREATE_INVALID_TIME_ID = "notifier.slot.invalid_time_id",
    SLOT_TIME_CREATE_DUPLICATED_SLOT = "notifier.slot.duplicated_slot",
    SLOT_ALREADY_BOOKED = "notifier.slot.already_booked",
    SLOT_INVALID_IDENTIFIER = "notifier.slot.invalid_identifier",
    SLOT_INVALID_PHONE_NUMBER = "notifier.slot.invalid_phone_number",
    SLOT_INVALID_NAME = "notifier.slot.invalid_name",
    SLOT_INVALID_SURNAME = "notifier.slot.invalid_surname",

    COPIED_TO_CLIPBOARD = "notifier.clipboard.copied",
    NOT_COPIED_TO_CLIPBOARD = "notifier.clipboard.not_copied",

    BOOKABLE_DAY_NOT_EXIST = "notifier.slot.bookable_day_not_exist",

    GENERIC_ERROR = "notifier.generic.error",
    GENERIC_MISSING_PARAM = "notifier.generic.missing_mandatory_param",

    NOT_ALLOWED = "notifier.authentication.not_allowed",
    OPERATION_OK = "notifier.operation.ok",
}

export function isNotifierMessage( value: any )
{
    return Object.values(NotifierMessage).includes(value)
}
